import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'kt-acces',
  templateUrl: './acces.component.html',
  styleUrls: ['./acces.component.scss']
})
export class AccesComponent implements OnInit {

  validate: boolean = false;
  mdp: boolean = false;
  email: any;
  iddossier: any;

  constructor(
    public dialogRef: MatDialogRef<AccesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService : AppService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    if(this.data.email_valid)
      this.validate = this.data.email_valid;
    if(this.data.password)
      this.mdp = this.data.password;
    if(this.data.email)
      this.email = this.data.email;
    if(this.data.id)
      this.iddossier = this.data.id;
  }

  sendValidation() {
    this.appService.sendValidationUser(this.iddossier, this.email).subscribe((res) => {

      this.snackBar.open("Email de validation envoyé","", {
        duration : 3000
      });
    });
  }

  sendMDP() {
    this.appService.sendPassword(this.iddossier).subscribe((res) => {

      this.snackBar.open("Email de réinitialisation de MDP envoyé","", {
        duration : 3000,
      });

    });
  }
}
